import { Dropdown } from '@digdir/designsystemet-react';

import styled from '../../../../styled';

export const CardContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--ds-size-4);
  align-items: center;
`;

export const CardContentColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MenuDropdownButton = styled(Dropdown.Button)`
  width: 100%;
  border-radius: var(--ds-border-radius-md);
`;
